import { Popover } from "@progress/kendo-react-tooltip";
import { faCalendar, faClock, faUser } from "@fortawesome/free-solid-svg-icons";
import { formatDate } from "@telerik/kendo-intl";
import * as React from "react";
import { useContext } from "react";
import StyledPageMenuIcon from "../../Layout/PageMenu/PageMenuIcon";
import { EditProjectContext } from "./EditProjectContext";
import { kendoDefaultDateFormatddMMyyyy } from "../../Utils/dates";

export default function AuditLogPopover({
  show,
  anchor,
}: {
  show: boolean;
  anchor: React.RefObject<HTMLElement>;
}) {
  const { project } = useContext(EditProjectContext);

  return (
    <Popover show={show} anchor={anchor.current} position="right">
      <div style={{ margin: 5 }}>
        <b>Modified</b>
        <p>
          <StyledPageMenuIcon icon={faCalendar} />{" "}
          {formatDate(project.LastModified as Date, kendoDefaultDateFormatddMMyyyy)}
        </p>
        <p>
          <StyledPageMenuIcon icon={faClock} />{" "}
          {formatDate(project.LastModified as Date, "HH:mm")}
        </p>
        <p>
          <StyledPageMenuIcon icon={faUser} /> {project.LastModifiedUser}
        </p>
      </div>
    </Popover>
  );
}
